var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("aside", { staticClass: "ai-agent-sidebar d-none" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ai-agent-body flex flex-col flex-grow-1" },
      [
        _vm._l(_vm.messages, function (message, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "ai-card mb-2",
              class: { "d-none": message.hidden },
            },
            [
              _c("div", { staticClass: "p-3" }, [
                _c(
                  "p",
                  {
                    staticClass: "mb-0",
                    staticStyle: { "white-space": "pre-wrap" },
                  },
                  [_vm._v(_vm._s(message.content))]
                ),
              ]),
            ]
          )
        }),
        _vm._v(" "),
        _vm.loading
          ? _c("div", { staticClass: "ai-card mb-2" }, [_vm._m(1)])
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "flex-shrink-0 ai-card p-2" }, [
      _c("div", { staticClass: "input-group" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.aiInput,
              expression: "aiInput",
            },
          ],
          staticClass: "form-control border-0",
          attrs: {
            type: "text",
            placeholder: "Ask AI Agent...",
            disabled: _vm.loading,
          },
          domProps: { value: _vm.aiInput },
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.sendMessage.apply(null, arguments)
            },
            input: function ($event) {
              if ($event.target.composing) return
              _vm.aiInput = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { type: "button", disabled: _vm.loading },
            on: { click: _vm.sendMessage },
          },
          [
            _vm.loading
              ? _c(
                  "div",
                  {
                    staticClass: "spinner-border spinner-border-sm",
                    attrs: { role: "status" },
                  },
                  [
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v("Loading..."),
                    ]),
                  ]
                )
              : _c("i", { staticClass: "bi bi-arrow-up" }),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "ai-agent-header flex-shrink-0 p-3 border-bottom border-light",
      },
      [
        _c(
          "div",
          { staticClass: "d-flex align-items-center justify-content-between" },
          [
            _c(
              "div",
              { staticClass: "ai-brand d-flex align-items-center gap-2" },
              [_vm._v("\n        It'sRapid AI Agent\n      ")]
            ),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "p-3" }, [
      _c(
        "p",
        {
          staticClass: "mb-0 d-flex align-items-center",
          staticStyle: { "white-space": "pre-wrap" },
        },
        [
          _vm._v("Thinking... "),
          _c(
            "span",
            {
              staticClass: "spinner-border spinner-border-sm ml-2",
              attrs: { role: "status" },
            },
            [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "input-group-text bg-transparent border-0" },
      [_c("i", { staticClass: "bi bi-chat-dots" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }